import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BusinessCardOpeningTime } from '@warema/shared/company-search/models';
import { WeekDayPipe } from '@warema/shared/pipes';

@Component({
    selector: 'warema-business-card-opening-times',
    templateUrl: './business-card-opening-times.component.html',
    styleUrls: ['./business-card-opening-times.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, WeekDayPipe],
})
export class BusinessCardOpeningTimesComponent implements OnInit {
    private readonly _maxOpeningTimes = 3;
    private _numberOfTimeIntervals = 0;
    public openingTimesCanBeShown = false;

    public readonly openingTimes = input<Array<BusinessCardOpeningTime> | undefined>(undefined);

    public ngOnInit(): void {
        const openingTimes = this.openingTimes();
        if (openingTimes && openingTimes.length > 0) {
            openingTimes.forEach(openingTime => {
                this._numberOfTimeIntervals += openingTime.timeIntervals.length;
            });
            if (this._numberOfTimeIntervals <= this._maxOpeningTimes) {
                this.openingTimesCanBeShown = true;
            }
        } else {
            this.openingTimesCanBeShown = false;
        }
    }
}
